import React from "react";
import { translateText } from "../../../../../../Helper_functions";
import TableFilter from "../../../ShareElements/TableFilter/TableFilter";

const DataTable = (props) => {
  const shortenFileName = (Name) => {
    if (Name.length < 43) {
      return Name;
    } else {
      return Name.slice(0, 39) + " ...";
    }
  };

  const convertDate = (ItemDate) => {
    let UpdateDate = new Date(ItemDate).toDateString();
    let Hours = new Date(ItemDate).getHours();
    let Minutes = new Date(ItemDate).getMinutes();
    return UpdateDate + " " + Hours + ":" + Minutes;
  };

  const nameFilterChange = () => {
    props.FilterByFileName();
    if (document.getElementById("Transfer Date-pointer-up") !== null) {
      document
        .getElementById("Transfer Date-pointer-up")
        .classList.remove("active-filter");
      document
        .getElementById("Transfer Date-pointer-down")
        .classList.remove("active-filter");
    }
  };

  const dateFilterChange = () => {
    props.FilterByDate();
    document
      .getElementById("File Name-pointer-up")
      .classList.remove("active-filter");
    document
      .getElementById("File Name-pointer-down")
      .classList.remove("active-filter");
  };

  return (
    <React.Fragment>
      <div className="history-form">
        <section className="form-head">
          <div className="large">
            <TableFilter
              className="with-padding-left sorts"
              Name={translateText("file_name", props.LangData)}
              Id="File Name"
              ChangeEvent={() => nameFilterChange()}
            />
          </div>
          <div className="small">
            <TableFilter
              className="with-padding-left sorts"
              Name={translateText("transfer_date", props.LangData)}
              Id="Transfer Date"
              ChangeEvent={() => dateFilterChange()}
              IsActive
            />
          </div>
          <div className="large">
            <h1 className="info-text">
              {translateText("no_of_imported_records", props.LangData)}
            </h1>
          </div>
          <div className="small">
            <h1 className="info-text">
              {translateText("imported_by", props.LangData)}
            </h1>
          </div>
        </section>
        {props.Data === undefined ? null : (
          <React.Fragment>
            {props.Data.map((Record) => (
              <div key={Record.id} className="record-item">
                <div className="large">
                  <p>{shortenFileName(Record.fileName)}</p>
                </div>
                <div className="small">
                  <p>{convertDate(Record.updatedTime)}</p>
                </div>
                <div className="large">
                  <p className="numbers">{Record.totalRecords}</p>
                </div>
                <div className="small">
                  {Record.importedByFirstName ? (
                    <h1 className="info-text">
                      {Record.importedByFirstName +
                        " " +
                        Record.importedByLastName}
                    </h1>
                  ) : (
                    <h1 className="info-text">
                      {translateText("not_available", props.LangData)}
                    </h1>
                  )}
                </div>
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default DataTable;
